import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Button from 'components/UI/Button/Button'
import Link from 'components/UI/Link'

import {
  Wrapper,
  StyledTitle,
  StyledFormInput,
  UpgradePromo,
  UpgradeMessage
} from './SchoolDetailsColumn.styles'
import { colors } from 'modules/dashboard/Home/Dashboard.global.styles'

export default class SchoolDetailsColumn extends Component {
  constructor (props) {
    super(props)

    this.state = {
      screenWidth: 0
    }

    this.onInputChange = this.onInputChange.bind(this)
    this.updateScreenWidth = this.updateScreenWidth.bind(this)
  }

  static propTypes = {
    setSchoolState: PropTypes.func,
    subscriptionStatus: PropTypes.string,
    subscriptionEndDate: PropTypes.number,
    info: PropTypes.shape({
      name: PropTypes.string,
      twitter: PropTypes.string
    }),
    isEditMode: PropTypes.bool
  }

  static defaultProps = {
    info: {},
    setSchoolState: () => {},
    subscriptionStatus: '',
    subscriptionEndDate: ''
  }

  componentDidMount () {
    this.updateScreenWidth()
    window.addEventListener('resize', this.updateScreenWidth)
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.updateScreenWidth)
  }

  updateScreenWidth () {
    const screenWidth = window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth
    this.setState({ screenWidth })
  }

  onInputChange (e) {
    this.props.setSchoolState({
      field: e.target.name,
      value: e.target.value
    })
  }

  renderUpgradePromo () {
    const { subscriptionStatus, subscriptionEndDate } = this.props
    if (!['trial', 'expired'].includes(subscriptionStatus)) return null

    const now = (new Date()).getTime()
    const daysLeft = Math.ceil((subscriptionEndDate - now) / (1000 * 3600 * 24))

    return (
      <UpgradePromo>
        {subscriptionStatus === 'trial' &&
        <UpgradeMessage>
          {`Your free trial ends in ${daysLeft} days`}
        </UpgradeMessage>
        }
        <Link to='/dashboard/settings/subscription'>
          <Button
            bgColor={colors.red}
            color={colors.yellow}
            size='regular'
          >
            Upgrade
          </Button>
        </Link>
      </UpgradePromo>
    )
  }

  render () {
    const { info, isEditMode, subscriptionStatus } = this.props
    const { screenWidth } = this.state

    const commonProps = {
      placeholderColor: isEditMode ? colors.grey : colors.orange,
      backgroundColor: isEditMode ? null : colors.paleBlue,
      inputColor: isEditMode ? null : colors.darkPurple,
      fieldNameColor: colors.pink,
      noBorder: !isEditMode,
      focusColor: colors.orange,
      backgroundFocusColor: colors.lightOrange,
      element: 'button',
      disabled: !isEditMode,
      autoComplete: 'off',
      narrow: true,
      textSize: '15px',
      fieldNameSize: '18px',
      width: screenWidth <= 950 ? '180px' : '220px'
    }

    return (
      <Wrapper>
        <StyledTitle>
          School Details
        </StyledTitle>
        <StyledFormInput
          {...commonProps}
          value={info.name}
          onChange={this.onInputChange}
          name='name'
          fieldName='School Name'
          placeholder='School name'
          required
        />
        {subscriptionStatus !== 'trial' &&
        <StyledFormInput
          {...commonProps}
          value={info.twitter}
          onChange={this.onInputChange}
          name='twitter'
          fieldName='School Twitter'
          placeholder='School twitter'
        />
        }
        {this.renderUpgradePromo()}
      </Wrapper>
    )
  }
}
